import React, { useState } from "react";
import RoomIcon from "@mui/icons-material/Room";
import "./HotelDetailCard.scss";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import MuiButton from "../../../components/basicComponent/MuiButton";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';

interface Image {
  id: number;
  url: string;
  alt: string;
}
interface HotelDetailCardProps {
  hotel: any; 
}
const images: Image[] = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1590073242678-70ee3fc28e8e?auto=format&fit=crop&q=80&w=1200",
    alt: "Hotel Exterior Night View",
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&q=80&w=800",
    alt: "Luxury Hotel Room",
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&q=80&w=1200",
    alt: "Hotel Restaurant",
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1584132967334-10e028bd69f7?auto=format&fit=crop&q=80&w=1200",
    alt: "Conference Room",
  },
];

const HotelDetailCard: React.FC<HotelDetailCardProps> = ({ hotel }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const previousImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleThumbnailClick = (index: number) => {
    setCurrentImageIndex(index);
    setShowLightbox(true);
  };

  return (
    <>
      <div className="card my-3">
        <div className="row g-0">
          <div className="col-md-6">
            {/* Image Gallery */}

            <div className="container p-3">
              {/* Main Gallery */}
              <div className="row mb-3">
                <div className="col-12">
                  <div className="position-relative">
                    <img
                      src={images[currentImageIndex].url}
                      alt={images[currentImageIndex].alt}
                      className="w-100 rounded-4 "
                      style={{
                        height: "334px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      onClick={() => setShowLightbox(true)}
                    />
                    <button
                      className="btn btn-light rounded-circle position-absolute top-50 start-0 translate-middle-y ms-3 d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                      onClick={previousImage}
                    >
                      <KeyboardArrowLeftIcon />
                    </button>
                    <button
                      className="btn btn-light rounded-circle position-absolute top-50 end-0 translate-middle-y me-3 d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                      onClick={nextImage}
                    >
                      <ChevronRightIcon />
                    </button>
                  </div>
                </div>
              </div>

              {/* Thumbnails */}
              <div className="row g-3">
                {images.map((image, index) => (
                  <div key={image.id} className="col-3">
                    <div
                      className={`position-relative cursor-pointer ${
                        index === currentImageIndex
                          ? "ring ring-primary ring-2"
                          : ""
                      }`}
                      onClick={() => handleThumbnailClick(index)}
                    >
                      <img
                        src={image.url}
                        alt={image.alt}
                        className="w-100 rounded-3"
                        style={{ height: "120px", objectFit: "cover" }}
                      />
                      {index === currentImageIndex && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 bg-primary bg-opacity-25 rounded-3" />
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Lightbox */}
              {showLightbox && (
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-75 d-flex align-items-center justify-content-center"
                  style={{ zIndex: 1050 }}
                  onClick={() => setShowLightbox(false)}
                >
                  <div
                    className="position-relative"
                    style={{ maxWidth: "90vw", maxHeight: "90vh" }}
                  >
                    <img
                      src={images[currentImageIndex].url}
                      alt={images[currentImageIndex].alt}
                      className="img-fluid rounded-4"
                      style={{ maxHeight: "90vh" }}
                    />
                    <button
                      className="btn btn-light rounded-circle position-absolute top-0 end-0 translate-middle"
                      onClick={() => setShowLightbox(false)}
                    >
                      <ClearOutlinedIcon />
                    </button>
                    <button
                      className="btn btn-light rounded-circle position-absolute top-50 start-0 translate-middle-y ms-3"
                      onClick={(e) => {
                        e.stopPropagation();
                        previousImage();
                      }}
                    >
                     <KeyboardArrowLeftIcon />
                    </button>
                    <button
                      className="btn btn-light rounded-circle position-absolute top-50 end-0 translate-middle-y me-3"
                      onClick={(e) => {
                        e.stopPropagation();
                        nextImage();
                      }}
                    >
                      <ChevronRightIcon />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            {/* Header Section */}
            <div className="hotel-card-header border-bottom  p-4">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h4 className="h3 fw-bold">
                    Southend By TGI <span className="stars">★★★★★</span>
                  </h4>
                  <div className="d-flex align-items-center">
                    <RoomIcon className="text-secondary" />
                    <p className="depar-info">
                      Near, #21, 5Th Cross, Vidyanagar, Hosur Road, Bommasandra,
                      Electronic City, Bengaluru
                    </p>
                  </div>
                </div>
                <div className="text-end">
                  <div className="rating-badge d-inline-flex align-items-center">
                    <span className="fw-semibold me-1">5.0</span>
                    <StarBorderIcon />
                  </div>
                  <p className="text-secondary small mt-1 mb-0">116 reviews</p>
                </div>
              </div>
            </div>
            {/* Room Details */}
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h2 className="Premium-room">Premium Room</h2>
                  <p className="text-secondary mb-0">1 x Guest | 1 x Room</p>
                </div>
                <div className="text-end">
                  <p className=" old-prices">₹4,750</p>
                  <p className="h3 fw-bold">₹2,529</p>
                  <p className="text-secondary small">₹355 Taxes & fees</p>
                  <p className="text-secondary small">Base price (Per Night)</p>
                </div>
              </div>

              {/* Amenities */}
              <div className="mt-2">
                <h3 className="h5 fw-semibold mb-3">Room Amenities</h3>
                <div className="row row-cols-2 row-cols-md-4 g-1">
                  <div className="col ">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Bath className="amenity-icon" /> */}
                      <span className="text-secondary">
                        <DoneAllIcon /> Free toiletries
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Iron className="amenity-icon" /> */}
                      <span className="text-secondary">
                        <DoneAllIcon /> Ironing facilities
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Car className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> Parking facility
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Briefcase className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> Luggage Storage
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Clock className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> 24/7 Front Desk
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Coffee className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> Restaurant
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Wifi className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> Free Wi-Fi
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Tv className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> Flat-screen TV
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="d-flex align-items-center gap-2">
                      {/* <Phone className="amenity-icon" /> */}
                      <span className="text-secondary">
                        {" "}
                        <DoneAllIcon /> 24/7 Support
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-button  mt-4  gap-3">
                <MuiButton
                  className="clear-btn w-auto px-4 rounded-pill"
                  label="Select Rooms"
                  type="submit"
                />
                <MuiButton
                  className=" get-btn w-auto px-5 rounded-pill"
                  label="Book Now"
                  onClick={() => {}}
                  type="submit"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HotelDetailCard;
